import React from 'react';
import { FontSize, FontWeight } from '@common/tokens';
import { TextOverflow } from '@common/components/text-overflow';
import { CommentInfoFragmentType } from '@common/graphql';

export const CommentInline = ({
  comment,
  prefix,
}: {
  prefix?: string;
  comment: CommentInfoFragmentType;
}) => {
  return (
    <>
      <TextOverflow>
        <span className="comment-subtext">{`${prefix}"${comment.contentAsText}"`}</span>
      </TextOverflow>
      <style jsx>{`
        :global(.comment-subtext) {
          display: block;
          font-size: ${FontSize.md};
          font-weight: ${FontWeight.light};
        }
      `}</style>
    </>
  );
};
